module.exports = __webpack_public_path__ + "static/img/sustainable-strategy_01_202512.ef64159.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/sustainable-strategy_01_202512.jpg
// module id = Cvhp
// module chunks = 100